// extracted by mini-css-extract-plugin
export default {"emptyChapterCardBlock":"EmptyChapterCard_emptyChapterCardBlock__6U5rp","emptyChapterCardImg":"EmptyChapterCard_emptyChapterCardImg__ZChhL","text":"EmptyChapterCard_text__cEL5w"};